import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../Provider/AuthProvider'
import { doLogout } from '../State/Functions'

const roleBasedMenu = () => ({
  siapAdmin: [
    { label: 'Dashboard', icon: 'Dashboard', path: 'dashboard' },
    { label: 'Processi', icon: 'Description', path: 'siapadmin/processes' },
    { label: 'Agenzie', icon: 'Business', path: 'siapadmin/agencies' },
    { label: 'Server FTP', icon: 'Dns', path: 'siapadmin/servers' },
    { label: 'Utenti', icon: 'People', path: 'siapadmin/users' },
    { label: 'Configurazioni PNR', icon: 'Build', path: 'siapadmin/configs' },
    { label: 'Logs', icon: 'Article', path: 'siapadmin/logs' },
    { label: 'Manutenzione', icon: 'Engineering', path: 'siapadmin/maintenance' },
    { label: 'Impostazioni', icon: 'Settings', path: 'siapadmin/settings' }
  ],
  siapDeveloper: [
    { label: 'Dashboard', icon: 'Dashboard', path: 'dashboard' },
    { label: 'Processi', icon: 'Description', path: 'siapdeveloper/processes' },
    { label: 'Agenzie', icon: 'Business', path: 'siapdeveloper/agencies' }
  ],
  agencyAdmin: [
    { label: 'Dashboard', icon: 'Dashboard', path: 'dashboard' },
    { label: 'Processi', icon: 'Description', path: 'admin/processes' },
  ]
})

export const usePageTitle = () => {
  const location = useLocation()
  const currentPath = location.pathname

  if (currentPath === '/') return 'Dashboard'

  const pathMap = () => ([
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/siapadmin/processes', label: 'Processi' },
    { path: '/siapadmin/agencies', label: 'Agenzie' },
    { path: '/siapadmin/servers', label: 'Server FTP' },
    { path: '/siapadmin/users', label: 'Utenti' },
    { path: '/siapadmin/configs', label: 'Configurazioni PNR' },
    { path: '/siapadmin/logs', label: 'Logs' },
    { path: '/siapadmin/maintenance', label: 'Manutenzione' },
    { path: '/siapadmin/settings', label: 'Impostazioni' },
    { path: '/siapdeveloper/processes', label: 'Processi' },
    { path: '/siapdeveloper/agencies', label: 'Agenzie' },
    { path: '/admin/processes', label: 'Processi' },
    { path: '/admin/clients', label: 'Client' },
    { path: '/admin/configs', label: 'Configurazioni PNR' },
    { path: '/commonop/processes', label: 'Processi' },
    { path: '/commonop/configs', label: 'Configurazioni PNR' }
  ])

  const matchedTitle = pathMap().find((route) => currentPath.startsWith(route.path))
  return matchedTitle?.label || 'Dashboard'
}

export const useMenuItems = () => {
  const navigate = useNavigate()
  const user = useAuth()?.user?.user
  const menuItems = roleBasedMenu()[user?.role]

  return menuItems?.map((item) => ({
    ...item,
    action: () => {
      if (item.path === 'logout') {
        doLogout()
      } else {
        navigate(item.path)
      }
    }
  }))
}
